import { render, staticRenderFns } from "./AnomalyDashboard.vue?vue&type=template&id=5d90d3d0&scoped=true&"
import script from "./AnomalyDashboard.vue?vue&type=script&lang=js&"
export * from "./AnomalyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AnomalyDashboard.vue?vue&type=style&index=0&id=5d90d3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90d3d0",
  null
  
)

export default component.exports